export const Pokedex: {[k: string]: ModdedSpeciesData} = {
	bulbasaur: {
		inherit: true,
		maleOnlyHidden: true,
	},
	ivysaur: {
		inherit: true,
		maleOnlyHidden: true,
	},
	venusaur: {
		inherit: true,
		maleOnlyHidden: true,
	},
	charmander: {
		inherit: true,
		maleOnlyHidden: true,
	},
	charmeleon: {
		inherit: true,
		maleOnlyHidden: true,
	},
	charizard: {
		inherit: true,
		maleOnlyHidden: true,
	},
	squirtle: {
		inherit: true,
		maleOnlyHidden: true,
	},
	wartortle: {
		inherit: true,
		maleOnlyHidden: true,
	},
	blastoise: {
		inherit: true,
		maleOnlyHidden: true,
	},
	butterfree: {
		inherit: true,
		baseStats: {hp: 60, atk: 45, def: 50, spa: 80, spd: 80, spe: 70},
	},
	beedrill: {
		inherit: true,
		baseStats: {hp: 65, atk: 80, def: 40, spa: 45, spd: 80, spe: 75},
	},
	pidgeot: {
		inherit: true,
		baseStats: {hp: 83, atk: 80, def: 75, spa: 70, spd: 70, spe: 91},
	},
	pikachu: {
		inherit: true,
		baseStats: {hp: 35, atk: 55, def: 30, spa: 50, spd: 40, spe: 90},
	},
	raichu: {
		inherit: true,
		baseStats: {hp: 60, atk: 90, def: 55, spa: 90, spd: 80, spe: 100},
	},
	nidoqueen: {
		inherit: true,
		baseStats: {hp: 90, atk: 82, def: 87, spa: 75, spd: 85, spe: 76},
	},
	nidoking: {
		inherit: true,
		baseStats: {hp: 81, atk: 92, def: 77, spa: 85, spd: 75, spe: 85},
	},
	clefairy: {
		inherit: true,
		types: ["Normal"],
	},
	clefable: {
		inherit: true,
		types: ["Normal"],
		baseStats: {hp: 95, atk: 70, def: 73, spa: 85, spd: 90, spe: 60},
	},
	jigglypuff: {
		inherit: true,
		types: ["Normal"],
		abilities: {0: "Cute Charm", H: "Friend Guard"},
	},
	wigglytuff: {
		inherit: true,
		types: ["Normal"],
		baseStats: {hp: 140, atk: 70, def: 45, spa: 75, spd: 50, spe: 45},
		abilities: {0: "Cute Charm", H: "Frisk"},
	},
	vileplume: {
		inherit: true,
		baseStats: {hp: 75, atk: 80, def: 85, spa: 100, spd: 90, spe: 50},
	},
	poliwrath: {
		inherit: true,
		baseStats: {hp: 90, atk: 85, def: 95, spa: 70, spd: 90, spe: 70},
	},
	alakazam: {
		inherit: true,
		baseStats: {hp: 55, atk: 50, def: 45, spa: 135, spd: 85, spe: 120},
	},
	victreebel: {
		inherit: true,
		baseStats: {hp: 80, atk: 105, def: 65, spa: 100, spd: 60, spe: 70},
	},
	golem: {
		inherit: true,
		baseStats: {hp: 80, atk: 110, def: 130, spa: 55, spd: 65, spe: 45},
	},
	mrmime: {
		inherit: true,
		types: ["Psychic"],
	},
	articuno: {
		inherit: true,
		unreleasedHidden: true,
	},
	zapdos: {
		inherit: true,
		abilities: {0: "Pressure", H: "Lightning Rod"},
		unreleasedHidden: true,
	},
	moltres: {
		inherit: true,
		unreleasedHidden: true,
	},
	chikorita: {
		inherit: true,
		unreleasedHidden: true,
	},
	bayleef: {
		inherit: true,
		unreleasedHidden: true,
	},
	meganium: {
		inherit: true,
		unreleasedHidden: true,
	},
	cyndaquil: {
		inherit: true,
		unreleasedHidden: true,
	},
	quilava: {
		inherit: true,
		unreleasedHidden: true,
	},
	typhlosion: {
		inherit: true,
		unreleasedHidden: true,
	},
	totodile: {
		inherit: true,
		unreleasedHidden: true,
	},
	croconaw: {
		inherit: true,
		unreleasedHidden: true,
	},
	feraligatr: {
		inherit: true,
		unreleasedHidden: true,
	},
	igglybuff: {
		inherit: true,
		types: ["Normal"],
		abilities: {0: "Cute Charm", H: "Friend Guard"},
	},
	togepi: {
		inherit: true,
		types: ["Normal"],
	},
	togetic: {
		inherit: true,
		types: ["Normal", "Flying"],
	},
	cleffa: {
		inherit: true,
		types: ["Normal"],
	},
	ampharos: {
		inherit: true,
		baseStats: {hp: 90, atk: 75, def: 75, spa: 115, spd: 90, spe: 55},
	},
	bellossom: {
		inherit: true,
		baseStats: {hp: 75, atk: 80, def: 85, spa: 90, spd: 100, spe: 50},
	},
	marill: {
		inherit: true,
		types: ["Water"],
	},
	azumarill: {
		inherit: true,
		types: ["Water"],
		baseStats: {hp: 100, atk: 50, def: 80, spa: 50, spd: 80, spe: 50},
	},
	jumpluff: {
		inherit: true,
		baseStats: {hp: 75, atk: 55, def: 70, spa: 55, spd: 85, spe: 110},
	},
	snubbull: {
		inherit: true,
		types: ["Normal"],
	},
	granbull: {
		inherit: true,
		types: ["Normal"],
	},
	tyrogue: {
		inherit: true,
		maleOnlyHidden: true,
	},
	hitmonlee: {
		inherit: true,
		maleOnlyHidden: true,
	},
	hitmonchan: {
		inherit: true,
		maleOnlyHidden: true,
	},
	hitmontop: {
		inherit: true,
		maleOnlyHidden: true,
	},
	treecko: {
		inherit: true,
		maleOnlyHidden: true,
	},
	grovyle: {
		inherit: true,
		maleOnlyHidden: true,
	},
	sceptile: {
		inherit: true,
		maleOnlyHidden: true,
	},
	torchic: {
		inherit: true,
		maleOnlyHidden: true,
	},
	combusken: {
		inherit: true,
		maleOnlyHidden: true,
	},
	blaziken: {
		inherit: true,
		maleOnlyHidden: true,
	},
	mudkip: {
		inherit: true,
		maleOnlyHidden: true,
	},
	marshtomp: {
		inherit: true,
		maleOnlyHidden: true,
	},
	swampert: {
		inherit: true,
		maleOnlyHidden: true,
	},
	beautifly: {
		inherit: true,
		baseStats: {hp: 60, atk: 70, def: 50, spa: 90, spd: 50, spe: 65},
	},
	ralts: {
		inherit: true,
		types: ["Psychic"],
	},
	kirlia: {
		inherit: true,
		types: ["Psychic"],
	},
	gardevoir: {
		inherit: true,
		types: ["Psychic"],
	},
	exploud: {
		inherit: true,
		baseStats: {hp: 104, atk: 91, def: 63, spa: 91, spd: 63, spe: 68},
	},
	azurill: {
		inherit: true,
		types: ["Normal"],
	},
	mawile: {
		inherit: true,
		types: ["Steel"],
	},
	plusle: {
		inherit: true,
		abilities: {0: "Plus"},
	},
	minun: {
		inherit: true,
		abilities: {0: "Minus"},
	},
	kecleon: {
		inherit: true,
		abilities: {0: "Color Change"},
	},
	feebas: {
		inherit: true,
		abilities: {0: "Swift Swim", H: "Adaptability"},
	},
	milotic: {
		inherit: true,
		abilities: {0: "Marvel Scale", H: "Cute Charm"},
	},
	duskull: {
		inherit: true,
		abilities: {0: "Levitate"},
	},
	dusclops: {
		inherit: true,
		abilities: {0: "Pressure"},
	},
	regirock: {
		inherit: true,
		unreleasedHidden: true,
	},
	regice: {
		inherit: true,
		unreleasedHidden: true,
	},
	registeel: {
		inherit: true,
		unreleasedHidden: true,
	},
	turtwig: {
		inherit: true,
		maleOnlyHidden: true,
	},
	grotle: {
		inherit: true,
		maleOnlyHidden: true,
	},
	torterra: {
		inherit: true,
		maleOnlyHidden: true,
	},
	chimchar: {
		inherit: true,
		maleOnlyHidden: true,
	},
	monferno: {
		inherit: true,
		maleOnlyHidden: true,
	},
	infernape: {
		inherit: true,
		maleOnlyHidden: true,
	},
	piplup: {
		inherit: true,
		maleOnlyHidden: true,
	},
	prinplup: {
		inherit: true,
		maleOnlyHidden: true,
	},
	empoleon: {
		inherit: true,
		maleOnlyHidden: true,
	},
	starly: {
		inherit: true,
		abilities: {0: "Keen Eye"},
	},
	staraptor: {
		inherit: true,
		baseStats: {hp: 85, atk: 120, def: 70, spa: 50, spd: 50, spe: 100},
	},
	roserade: {
		inherit: true,
		baseStats: {hp: 60, atk: 70, def: 55, spa: 125, spd: 105, spe: 90},
	},
	mimejr: {
		inherit: true,
		types: ["Psychic"],
	},
	togekiss: {
		inherit: true,
		types: ["Normal", "Flying"],
	},
	dusknoir: {
		inherit: true,
		abilities: {0: "Pressure"},
	},
	snivy: {
		inherit: true,
		unreleasedHidden: true,
	},
	servine: {
		inherit: true,
		unreleasedHidden: true,
	},
	serperior: {
		inherit: true,
		unreleasedHidden: true,
	},
	tepig: {
		inherit: true,
		unreleasedHidden: true,
	},
	pignite: {
		inherit: true,
		unreleasedHidden: true,
	},
	emboar: {
		inherit: true,
		unreleasedHidden: true,
	},
	oshawott: {
		inherit: true,
		unreleasedHidden: true,
	},
	dewott: {
		inherit: true,
		unreleasedHidden: true,
	},
	samurott: {
		inherit: true,
		unreleasedHidden: true,
	},
	stoutland: {
		inherit: true,
		baseStats: {hp: 85, atk: 100, def: 90, spa: 45, spd: 90, spe: 80},
	},
	pansage: {
		inherit: true,
		maleOnlyHidden: true,
	},
	simisage: {
		inherit: true,
		maleOnlyHidden: true,
	},
	pansear: {
		inherit: true,
		maleOnlyHidden: true,
	},
	simisear: {
		inherit: true,
		maleOnlyHidden: true,
	},
	panpour: {
		inherit: true,
		maleOnlyHidden: true,
	},
	simipour: {
		inherit: true,
		maleOnlyHidden: true,
	},
	unfezant: {
		inherit: true,
		baseStats: {hp: 80, atk: 105, def: 80, spa: 65, spd: 55, spe: 93},
	},
	gigalith: {
		inherit: true,
		baseStats: {hp: 85, atk: 135, def: 130, spa: 60, spd: 70, spe: 25},
	},
	seismitoad: {
		inherit: true,
		baseStats: {hp: 105, atk: 85, def: 75, spa: 85, spd: 75, spe: 74},
	},
	leavanny: {
		inherit: true,
		baseStats: {hp: 75, atk: 103, def: 80, spa: 70, spd: 70, spe: 92},
	},
	venipede: {
		inherit: true,
		abilities: {0: "Poison Point", 1: "Swarm", H: "Quick Feet"},
	},
	whirlipede: {
		inherit: true,
		abilities: {0: "Poison Point", 1: "Swarm", H: "Quick Feet"},
	},
	scolipede: {
		inherit: true,
		baseStats: {hp: 60, atk: 90, def: 89, spa: 55, spd: 69, spe: 112},
		abilities: {0: "Poison Point", 1: "Swarm", H: "Quick Feet"},
	},
	cottonee: {
		inherit: true,
		types: ["Grass"],
	},
	whimsicott: {
		inherit: true,
		types: ["Grass"],
	},
	basculinbluestriped: {
		inherit: true,
		abilities: {0: "Rock Head", 1: "Adaptability", H: "Mold Breaker", S: "Reckless"},
	},
	krookodile: {
		inherit: true,
		baseStats: {hp: 95, atk: 117, def: 70, spa: 65, spd: 70, spe: 92},
	},
	gothita: {
		inherit: true,
		unreleasedHidden: true,
	},
	gothorita: {
		inherit: true,
		abilities: {0: "Frisk", H: "Shadow Tag"},
		maleOnlyHidden: true,
	},
	gothitelle: {
		inherit: true,
		abilities: {0: "Frisk", H: "Shadow Tag"},
		maleOnlyHidden: true,
	},
	ferrothorn: {
		inherit: true,
		abilities: {0: "Iron Barbs"},
	},
	klink: {
		inherit: true,
		unreleasedHidden: true,
	},
	litwick: {
		inherit: true,
		abilities: {0: "Flash Fire", 1: "Flame Body", H: "Shadow Tag"},
		unreleasedHidden: true,
	},
	lampent: {
		inherit: true,
		abilities: {0: "Flash Fire", 1: "Flame Body", H: "Shadow Tag"},
		unreleasedHidden: true,
	},
	chandelure: {
		inherit: true,
		abilities: {0: "Flash Fire", 1: "Flame Body", H: "Shadow Tag"},
		unreleasedHidden: true,
	},
	rufflet: {
		inherit: true,
		unreleasedHidden: true,
	},
	larvesta: {
		inherit: true,
		unreleasedHidden: true,
	},
	volcarona: {
		inherit: true,
		unreleasedHidden: true,
	},
};
